import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import JsFileDownloader from 'js-file-downloader'

export const downloadAttachment = async (url, name) => {
  if (url) {
    if (url.includes('https://')) {
      await new JsFileDownloader({
        url: url,
      })
        .then(res => {})
        .catch(error => {
          ErrorMessage(error, 'Something went wrong please try again!!')
        })
    } else {
      ErrorMessage('Invalid download url')
    }
  } else {
    ErrorMessage('There is no url to dowload!!')
  }
}
